import { OptionValue, type Option } from "../../../types/option";
import { type OptionFieldsConfig } from "..";

import { getValueKey } from "./getValueKey";

function exclude<TValue extends Option>(
  selected: OptionValue<TValue>[] | undefined,
  opt: TValue,
  fieldConfig: OptionFieldsConfig<TValue>,
): OptionValue<TValue>[] {
  if (!selected) {
    return [];
  }

  const optValueKey = getValueKey(opt, fieldConfig);

  return selected.filter((item) => {
    return getValueKey(item, fieldConfig) !== optValueKey;
  });
}

export { exclude };
